
import { useState, useEffect, useRef } from "react";
import { Col } from "react-bootstrap";

export default function Bell({ backgroundColor, time, item }) {
  const [hidden, setHidden] = useState(false);

  // Ref to prevent repeated dings for the same time
  const lastDisqPlayedRef = useRef(null);
  // Refs for audio elements
  const audioGreen = useRef(null);
  const audioYellow = useRef(null);
  const audioRed = useRef(null);
  const audioDisq = useRef(null);

  // Play disqualification sound at red+30s only once, and not when unmuting after the mark
  useEffect(() => {
    if (hidden) return;
    let redLimit = 0;
    if (item && item.agendaEvent && item.agendaEvent.red) {
      const [min, sec] = item.agendaEvent.red.split(":").map(Number);
      redLimit = min * 60 + (sec || 0);
    }
    if (redLimit > 0 && time === redLimit + 30 && lastDisqPlayedRef.current !== time) {
      if (audioDisq.current) {
        audioDisq.current.currentTime = 0;
        audioDisq.current.play();
      }
      lastDisqPlayedRef.current = time;
    }
    // Reset ref if time is before the mark
    if (time < redLimit + 30) {
      lastDisqPlayedRef.current = null;
    }
  }, [time, hidden, item]);

  // Only play sound when backgroundColor changes and is different from last played marker
  const lastMarkerPlayedRef = useRef(null);

  // Play sound on backgroundColor change
  const lastMarkerWhileHiddenRef = useRef(null);

  // Track the last marker passed while hidden
  useEffect(() => {
    if (hidden) {
      lastMarkerWhileHiddenRef.current = backgroundColor;
    }
  }, [backgroundColor, hidden]);

  useEffect(() => {
    if (hidden) return;
    // If we just unhid, and the marker was passed while hidden, skip playing sound for that marker
    if (lastMarkerWhileHiddenRef.current === backgroundColor) {
      lastMarkerPlayedRef.current = backgroundColor;
      lastMarkerWhileHiddenRef.current = null;
      return;
    }
    if (lastMarkerPlayedRef.current === backgroundColor) return;
    if (backgroundColor === "#146c43") {
      if (audioGreen.current) {
        audioGreen.current.currentTime = 0;
        audioGreen.current.play();
      }
      lastMarkerPlayedRef.current = backgroundColor;
    } else if (backgroundColor === "#ffc107") {
      if (audioYellow.current) {
        audioYellow.current.currentTime = 0;
        audioYellow.current.play();
      }
      lastMarkerPlayedRef.current = backgroundColor;
    } else if (backgroundColor === "#dc3545") {
      if (audioRed.current) {
        audioRed.current.currentTime = 0;
        audioRed.current.play();
      }
      lastMarkerPlayedRef.current = backgroundColor;
    } else if (backgroundColor === "#dc3544") {
      if (audioDisq.current) {
        audioDisq.current.currentTime = 0;
        audioDisq.current.play();
      }
      lastMarkerPlayedRef.current = backgroundColor;
    }
  }, [backgroundColor, hidden]);

  return (
    <Col
      xs={3}
      lg={3}
      className='d-flex justify-content-center align-items-center'
      style={{ cursor: 'pointer' }}
      onClick={() => setHidden((prev) => !prev)}
    >
      {/* Audio elements for beep sounds. Place these files in public folder. */}
      <audio ref={audioGreen} src="/sounds/beep-green.mp3" preload="auto" />
      <audio ref={audioYellow} src="/sounds/beep-yellow.mp3" preload="auto" />
      <audio ref={audioRed} src="/sounds/beep-red.mp3" preload="auto" />
      <audio ref={audioDisq} src="/sounds/beep-disq.mp3" preload="auto" />
      {hidden ? (
        <i className="bi bi-bell-slash" style={{ fontSize: '6vh', margin: 0 }}></i>
      ) : (
        <>
          <i className="bi bi-bell" style={{ fontSize: '6vh', margin: 0, marginRight: '0.5rem' }}></i>
        </>
      )}
    </Col>
  );
}
